import { render, staticRenderFns } from "./ClientEditPage.vue?vue&type=template&id=13fe974a&scoped=true"
import script from "./ClientEditPage.vue?vue&type=script&lang=ts"
export * from "./ClientEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fe974a",
  null
  
)

export default component.exports